<template>
  <div class="mt-4 flex justify-center gap-2">
    <button
      class="px-3 py-2 text-sm bg-gray-200 hover:bg-gray-300 rounded border"
      :disabled="currentPage === 1"
      @click="$emit('update:currentPage', currentPage - 1)"
    >
      {{ translate('Previous') }}
    </button>

    <button
      v-for="page in totalPages"
      :key="page"
      @click="$emit('update:currentPage', page)"
      :class="[
        'px-3 py-2 text-sm rounded border',
        currentPage === page ? 'bg-blue-500 text-white' : 'bg-gray-200 hover:bg-gray-300'
      ]"
      :disabled="currentPage === page"
    >
      {{ page }}
    </button>

    <button
      class="px-3 py-2 text-sm bg-gray-200 hover:bg-gray-300 rounded border"
      :disabled="currentPage === totalPages"
      @click="$emit('update:currentPage', currentPage + 1)"
    >
      {{ translate('Next') }}
    </button>
  </div>
</template>

<script>
import { translations } from '@/mixins';

export default {
  name: 'BasePagination',
  mixins: [translations],
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    }
  }
};
</script>